import React from 'react';
import { Department } from "@features/whereabouts/pages/departments/data/departments.models";
import styled from "styled-components";
import Colours from '@shared/ui/atoms/Colours';
import { BodyRegular } from '@shared/ui/atoms/fonts/Body';
import { OutlineButton } from '@shared/ui/atoms/buttons/OutlineButton';
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";

export function DepartmentContentCard(props: Props) {
  const history = useHistory();
  const {t} = useTranslation();
  const onClick = () => {
    if (props.onClick) {
      props.onClick(props.department);
    } else {
      history.push(`/manage/departments/${props.department.id}`);
    }
  }
  return (
    <ContentCard>
      <BodyRegular weight={600} colour={Colours.blue} style={{marginBottom: 10}}>{props.department.name}</BodyRegular>
      <BodyRegular style={{marginBottom: 16}}>{props.department.count} {t('general.team-members')}</BodyRegular>
      <OutlineButton text="button.edit-and-manage-department"
                     className="management__button"
                     style={{maxWidth: 242}}
                     click={onClick} />
    </ContentCard>
  )
}

interface Props {
  department: Department;
  onClick?: (department: Department) => void;
}


const ContentCard = styled.div`
  margin-bottom: 24px;
  border: 1px solid ${Colours.mildGrey};
  box-sizing: border-box;
  border-radius: 8px;
  padding: 16px 24px 24px 24px;
`
